export const settingsHubFr = {
  title: 'Paramètres',
  subtitle: 'Toutes les zones de configuration du locataire en un seul endroit.',
  personal: 'Personnel',
  configuration: 'Configuration',
  empty: "Aucune zone de configuration n'est disponible pour votre rôle.",
  areas: {
    setup: {
      title: 'Configuration et contrôle',
      description: 'Configuration guidée du tenant, progression, tests et validation.',
    },
    profile: {
      title: 'Mon profil',
      description: "Nom, langue et préférences d'affichage.",
    },
    security: {
      title: 'Sécurité',
      description: 'Mot de passe, authentification à deux facteurs et sessions actives.',
    },
    company: {
      title: "Profil de l'entreprise",
      description:
        'Données de base, coordonnées bancaires, numéro de TVA et textes de documents par défaut.',
    },
    users: {
      title: 'Utilisateurs et rôles',
      description: "Comptes d'équipe, matrice d'autorisation RBAC et double facteur obligatoire.",
    },
    pdfDesigner: {
      title: 'Concepteur PDF',
      description: 'Glissez-déposez des modèles de devis, de commandes et de factures.',
    },
    documentHeaders: {
      title: 'Données client dans les en-têtes',
      description: 'Gérer les champs, sections et visibilités par type de document.',
    },
    accounting: {
      title: 'DATEV et Intrastat',
      description:
        'Mappage de compte SKR03/04, numéro de conseiller et de client, exécutions de reporting.',
    },
    banking: {
      title: 'Banque et rapprochement',
      description: 'AISP, synchronisation, rapprochement, imputation et profils d’import sûrs.',
    },
    whatsapp: {
      title: 'API WhatsApp Business',
      description: "Jetons d'API Meta Cloud, webhooks et modèles de messages.",
    },
    notifications: {
      title: 'Notifications',
      description:
        'Règles de stock minimum, à consommer de préférence avant les avertissements et les paiements.',
    },
    salesRules: {
      title: 'Règles commerciales et suivi client',
      description: 'Simuler les recommandations, gérer les seuils et planifier les exécutions.',
    },
    translations: {
      title: 'Langues et traductions',
      description: 'Gérez la terminologie du locataire et les désignations protégées.',
    },
    customFields: {
      title: 'Champs personnalisés et coffre-fort GoBD',
      description: 'Champs supplémentaires dynamiques et journaux de modifications inviolables.',
    },
    system: {
      title: 'Système et sauvegardes',
      description: 'Test SMTP, sauvegardes de bases de données, import/export et télémétrie.',
    },
  },
  links: {
    setup: 'Ouvrir la configuration',
    company: "Modifier les données de l'entreprise",
    users: 'Gestion des utilisateurs',
    roles: 'Rôles et autorisations',
    securityLog: 'Journal de sécurité',
    templates: 'Modèles de documents',
    documentHeaders: 'Données client dans les en-têtes',
    accounting: 'Mappage de compte',
    datev: 'Exportation DATEV',
    intrastat: 'Etat Intrastat',
    banking: 'Configurer les services bancaires',
    whatsapp: 'Connexion et modèles',
    notifications: "Règles d'alerte",
    salesRules: 'Gérer les règles commerciales',
    translations: 'Glossaire de traduction',
    customFields: 'Champs personnalisés',
    auditVault: 'Coffre GoBD',
    system: 'État du système',
    errorLogs: "Centre d'erreurs",
    mailBackups: 'Serveur de messagerie et sauvegardes',
    dataHub: 'Importer et exporter',
  },
} as const;
